export default __webpack_public_path__ + "static/image-d-0b84c8b9a13765c300587cc3a03ab382.png";